import { render, staticRenderFns } from "./zhaocheTiHuo.vue?vue&type=template&id=ca2d582a&scoped=true&"
import script from "./zhaocheTiHuo.vue?vue&type=script&lang=js&"
export * from "./zhaocheTiHuo.vue?vue&type=script&lang=js&"
import style0 from "./zhaocheTiHuo.vue?vue&type=style&index=0&id=ca2d582a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2d582a",
  null
  
)

export default component.exports